import { render, staticRenderFns } from "./EmotionCommentsList.vue?vue&type=template&id=76d5c96c&scoped=true"
import script from "./EmotionCommentsList.vue?vue&type=script&lang=js"
export * from "./EmotionCommentsList.vue?vue&type=script&lang=js"
import style0 from "./EmotionCommentsList.vue?vue&type=style&index=0&id=76d5c96c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d5c96c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76d5c96c')) {
      api.createRecord('76d5c96c', component.options)
    } else {
      api.reload('76d5c96c', component.options)
    }
    module.hot.accept("./EmotionCommentsList.vue?vue&type=template&id=76d5c96c&scoped=true", function () {
      api.rerender('76d5c96c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/emotionComments/EmotionCommentsList.vue"
export default component.exports